<template lang="pug">
AppDropdown.app-map-button-dropdown
  template(#trigger)
    a.dropdown-toggle(data-toggle="dropdown")
      i.hi.hi-plus.hi-17
  slot
</template>

<script>
export default {
  name: 'AppMapDropdownButton',
};
</script>
